import algolia from 'algoliasearch';
import isEmpty from 'lodash/isEmpty';
import { VerbFetch } from '../../shared/VerbFetch';
import { ACTIONS } from '../Constants';
import { assignTeamDetails } from '../utils/CollectionUtils';
import { algoliaFilterStringBuilder, buildQueryString } from '../utils/StringUtils';

export const initializeAlgoliaSearchState = (params) => {
    const { pageName, initialState } = params;
    return (dispatch) =>
        dispatch({
            type: ACTIONS.ALGOLIA_STATE_INIT,
            payload: {
                pageName,
                initialState
            }
        });
};

export const postAlgoliaMultiSearch = (params) => {
    const {
        query,
        indexName,
        multiFilters = [],
        pageName,
        customSearchParams,
        defaultFilter,
        typeLabels = [],
        pathsContext,
        searchKey,
    } = params;
    const algoliaInstance = algolia(pathsContext.algoliaAppID, searchKey);
    return (dispatch, getState) => {
        dispatch({
            type: ACTIONS.ALGOLIA_SEARCH_START,
            payload: {
                pageName,
                query
            }
        });

        if (multiFilters.length) {
            const queries = multiFilters.map((filter) => ({
                indexName,
                query,
                params: {
                    filters: algoliaFilterStringBuilder(filter, defaultFilter, typeLabels),
                    ...customSearchParams
                }
            }));

            return algoliaInstance.multipleQueries(queries).then(({ results }) => {
                const response = results.reduce((acc, queryResult) => {
                    if (indexName === 'Collections') {
                        const { teams } = getState();
                        const teamCollections = assignTeamDetails(queryResult.hits, teams);
                        return acc.concat(teamCollections);
                    }
                    return acc.concat(queryResult.hits);
                }, []);
                dispatch({
                    type: ACTIONS.ALGOLIA_SEARCH_SUCCESS,
                    payload: {
                        pageName,
                        indexName,
                        searchResults: {
                            [indexName]: response
                        }
                    }
                });
                return response;
            });
        }
        dispatch({
            type: ACTIONS.ALGOLIA_SEARCH_SUCCESS,
            payload: {
                pageName,
                searchResults: {
                    [indexName]: []
                }
            }
        });
        return [];
    };
};

export const postAlgoliaSearch = (params) => {
    const { query, similarQuery, indexName, filters = {}, pageName, customSearchParams, defaultFilter, typeLabels = [], pathsContext, searchKey = '' } = params;
    const algoliaInstance = algolia(pathsContext.algoliaAppID, searchKey);
    const index = algoliaInstance.initIndex(indexName);
    return (dispatch, getState) => {
        dispatch({
            type: ACTIONS.ALGOLIA_SEARCH_START,
            payload: {
                pageName,
                query
            }
        });

        // this if check is too opinionated to Library for this generic action
        // TODO: move this logic to Library or its child components
        if (!filters.status || isEmpty(filters.status) || !filters._id || !isEmpty(filters._id)) {
            const searchQueryObject = {
                filters: algoliaFilterStringBuilder(filters, defaultFilter, typeLabels, indexName),
                ...customSearchParams,
            }
            if (similarQuery) {
                searchQueryObject.similarQuery = similarQuery;
            }
            return index
                .search(query, searchQueryObject)
                .then((response) => {
                    let { hits } = response;
                    if (indexName === 'Collections') {
                        const { teams } = getState();
                        hits = assignTeamDetails(hits, teams);
                    }
                    dispatch({
                        type: ACTIONS.ALGOLIA_SEARCH_SUCCESS,
                        payload: {
                            pageName,
                            indexName,
                            searchResults: {
                                [indexName]: hits
                            }
                        }
                    });
                    return hits;
                });
        }
        dispatch({
            type: ACTIONS.ALGOLIA_SEARCH_SUCCESS,
            payload: {
                pageName,
                searchResults: {
                    [indexName]: []
                }
            }
        });
        return [];
    };
};

export const updateAlgoliaSearchFilters = (params) => {
    const { filters, pageName } = params;
    return (dispatch) =>
        dispatch({
            type: ACTIONS.UPDATE_ALGOLIA_SEARCH_FILTERS,
            payload: {
                filters,
                pageName
            }
        });
};

export const updateAlgoliaSearchIndices = (params) => {
    const { indices, pageName } = params;
    return (dispatch) =>
        dispatch({
            type: ACTIONS.UPDATE_ALGOLIA_SEARCH_INDICES,
            payload: {
                indices,
                pageName
            }
        });
};

export const updateAlgoliaSearchQuery = (params) => {
    const { query, pageName, similarQuery } = params;
    return (dispatch) =>
        dispatch({
            type: ACTIONS.UPDATE_ALGOLIA_SEARCH_QUERY,
            payload: {
                query,
                similarQuery,
                pageName
            }
        });
};

export const clearAlgoliaSearchResult = (params) => {
    const { pageName } = params;
    return (dispatch) =>
        dispatch({
            type: ACTIONS.CLEAR_ALGOLIA_SEARCH_RESULT,
            payload: {
                pageName
            }
        });
};

export const getSearchKey = (params, pathsContext) => {
    const baseUrl = `${pathsContext.serverUrl}/search`;
    const url = buildQueryString(params, baseUrl)
    return VerbFetch(url);
  };